import type { ReactNode } from 'react';
import classnames from 'classnames';
import type { IconColor } from '../../atoms/icon/Icon';
import { Icon } from '../../atoms/icon/Icon';
import { Link } from '../../atoms/link/Link';
import * as styles from './IconLink.module.scss';

interface IIconLinkProps {
    children: ReactNode;
    className?: string;
    color?: IconColor;
    icon: string;
    linkColor?: 'white' | 'secondary' | 'warning' | 'info' | 'success' | 'black' | 'primary' | 'muted';
    noTextDecoration?: boolean;
    onClick?: () => void;
    openInNewTab?: boolean;
    position?: 'left' | 'right';
    to: string;
}

export function IconLink(props: IIconLinkProps) {
    let className = styles.iconLink;

    if (props.position) {
        className += props.position === 'left' ? ` ${styles.left}` : ` ${styles.right}`;
    }
    if (props.noTextDecoration) {
        className += ` ${styles.noTextDecoration}`;
    }

    const LinkIcon = (
        <Icon
            className={classnames(props.position === 'left' ? 'mr-1' : 'ml-1', styles.icon)}
            color={props.color}
            icon={props.icon}
            size="small"
        />
    );

    return (
        <Link
            className={classnames(className, props.className || '')}
            linkColor={props.linkColor}
            onClick={props.onClick}
            openInNewTab={props.openInNewTab}
            to={props.to}
        >
            <span>{props.children}</span>
            {LinkIcon}
        </Link>
    );
}
